module.exports = __webpack_public_path__ + "img/finances.b1774238.png";